import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);


const state = {
    isLoading: false,
    modalIsOpen: false,
    modalHeader: null,
    modalLabelFields: null,
    //currentLang: navigator.language || navigator.userLanguage,
    currentLang: 'de',
    isOldIEVersion: isOldIEVersion(),
    loggedIn: false,
    user: null,
    isImpersonating: false,
    isMenuOpen: true,
    redirectURL: '',
    taxonomies: [],
    taxonomiesRaw: [],
    catalogPageElements: null,
    catalogPagesTotal: 0,
    industryPartnerHasCatalogPage: false,
    industryPartnerCatalogPages: [],
    isExternal: false,
    labels: {
        de: {},
        en: {},
        fr: {},
        it: {}
    },
    catalogData: {},
    equipmentCatalogData: {},
    activeFilter: {
        campaigns: null,
        pim: null,
        products: {},
        pharmacies: {
            searchString: null,
            filterMutation: null,
            filterStatus: null,
            filterChangedPharmacies: null,
        },
        catalog: {},
        equipmentCatalog: {},
        equipments: {},
    },
    pimPharmacy: null,
    currentPimTablePage: 1,
    // routerHistory: [],
    pimProductPageTitle: '',
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters
})


// https://codepen.io/gapcode/pen/vEJNZN
function isOldIEVersion() {

    let ua = window.navigator.userAgent;
    let msie = ua.indexOf('MSIE ');

    // if IE is v10 or older, we return the version number
    if (msie > 0) {
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);

    // otherwise (IE is v11 or newer) we return false
    } else {
        return false;
    }

}
